export const downloadPdf = (data, fileName) => {
  const url = window.URL.createObjectURL(
    new Blob([data], { type: "application/pdf" })
  );

  const link = document.createElement("a");

  try {
    link.href = url;
    link.download = `${fileName}.pdf`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } finally {
    window.URL.revokeObjectURL(url);
  }
};